import React from "react";
import { CopyAll } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton/IconButton";
import trackEvent from "../utils/trackEvent";

interface CurlProps {
  type: 'http' | 'socks';
  url: string;
}

export default (props: CurlProps) => {
  const curl = (props.type === 'http') ?
    `curl --proxy ${props.url}  http://welcome.usefixie.com`
    : `curl --socks5-hostname ${props.url} http://welcome.usefixie.com`;
  return (<pre style={{ backgroundColor: '#333', border: '1px solid black', padding: '0.5rem 1rem', borderRadius: '0.5rem', color: 'white' }}>
    {curl}
    <IconButton aria-label="copy" color="primary" onClick={() => {
      trackEvent('copy_curl');
      navigator.clipboard.writeText(curl);
    }}>
      <CopyAll />
    </IconButton>
  </pre>)
}
